import React, { Fragment, useState, useEffect } from "react";
import { Input, Button, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import actions from "../actions";

const GtinFieldWithValidation = ({ action, field, onChange, state, value, errors }) => {
  const dispatch = useDispatch();
  const [validating, setValidating] = useState(false);
  const { t } = useTranslation("GtinFeild");

  const productState = useSelector((state) => state.get("products"));
  const validation = productState?.get ? productState.get("validation") : productState?.validation;
  const reduxLoading = productState?.get ? productState.get("loading") : productState?.loading;

  useEffect(() => {
    if (action === "create") {
      dispatch(actions.resetGtinValidation.request());
      onChange("__gtinValidated", false);
    }
  }, [action, dispatch, onChange]);

  useEffect(() => {
    return () => {
      if (action === "create") {
        dispatch(actions.resetGtinValidation.request());
      }
    };
  }, [action, dispatch]);

  const handleValidate = () => {
    if (value) {
      setValidating(true);
      dispatch(actions.validateGtin.request({ gtin: value }));
    }
  };

  useEffect(() => {
    if (validating && !reduxLoading) {
      setValidating(false);
    }
  }, [reduxLoading, validating]);

  useEffect(() => {
    const gtinValidated = validation?.gtinValidated;
    if (gtinValidated === true) {
      setValidating(false);
      onChange("__gtinValidated", true);
    }
  }, [validation?.gtinValidated, onChange]);

  useEffect(() => {
    const gtinValidationError = validation?.gtinValidationError;
    if (gtinValidationError) {
      setValidating(false);
    }
  }, [validation?.gtinValidationError]);

  let errorMessage = errors?.gtin || validation?.gtinValidationError;
  if (errorMessage === "requiredFields") {
    errorMessage = t("requiredField");
  }

  const isValidated = validation?.gtinValidated;

  if (action === "edit") {
    return (
      <Fragment>
        <div style={{ paddingBottom: "8px" }}>
          <label style={{ fontWeight: "bold" }}>{t("gtin")}</label>
        </div>
        <Input value={value} disabled={true} style={errorMessage ? { borderColor: "#ff4d4f" } : {}} />
        {errorMessage && <div style={{ color: "#ff4d4f", marginTop: "4px" }}>{errorMessage}</div>}
      </Fragment>
    );
  }

  const renderSuffix = () => {
    if (isValidated) {
      return <span style={{ color: "#52c41a", fontWeight: "500" }}>✓ {t("validated")}</span>;
    }

    if (validating) {
      return <Spin indicator={<LoadingOutlined style={{ fontSize: 16 }} spin />} />;
    }

    return (
      <a
        onClick={handleValidate}
        style={{
          color: !value ? "#d9d9d9" : "#1890ff",
          cursor: !value ? "not-allowed" : "pointer",
          fontSize: "14px",
          fontWeight: "500",
          pointerEvents: !value ? "none" : "auto",
        }}
      >
        {t("validate")}
      </a>
    );
  };

  return (
    <Fragment>
      <div style={{ paddingBottom: "8px" }}>
        <label style={{ fontWeight: "bold" }}>
          <span style={{ color: "#ff4d4f" }}>*</span> {t("gtin")}
        </label>
      </div>
      <Input
        value={value}
        onChange={(e) => onChange(field, e.target.value)}
        placeholder={t("gtin")}
        disabled={isValidated}
        suffix={renderSuffix()}
        style={errorMessage ? { borderColor: "#ff4d4f" } : {}}
      />
      {errorMessage && <div style={{ color: "#ff4d4f", marginTop: "4px" }}>{errorMessage}</div>}
    </Fragment>
  );
};

export default GtinFieldWithValidation;
